/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { blueGrey, grey } from '@mui/material/colors'
import Draggable from 'react-draggable'

interface PropsType {
	toolbar: JSX.Element
	document: JSX.Element
	isHandleMode: boolean
}

export const PdfReaderLayout = (props: PropsType) => {
	const { toolbar, document, isHandleMode } = props

	return (
		<View css={style}>
			<View className="pdfLayoutView">
				<View className="pdfToolbarLayoutView">{toolbar}</View>
				<View className="pdfDocumentLayoutView">
					<Draggable disabled={!isHandleMode}>{document}</Draggable>
				</View>
			</View>
		</View>
	)
}

const style = css({
	width: '100%',
	height: '100%',
	overflow: 'hidden',

	'.pdfLayoutView': {
		position: 'relative',
		width: '100%',
		height: '100%',
		border: '1px solid',
		borderColor: grey[300],
		overflow: 'hidden',

		'.pdfToolbarLayoutView': {
			position: 'absolute',
			zIndex: 5,
			width: '100%',
			height: '3.5rem',
			top: 0,
			boxShadow: `0px 1px 3px 1px ${grey[400]}`,
			background: '#fff',
			overflow: 'hidden',
		},

		'.pdfDocumentLayoutView': {
			position: 'relative',
			width: '100%',
			height: '100%',
			paddingTop: '3.5rem',
			background: blueGrey[50],
		},
	},

	'@media (max-width: 900px)': {
		'.pdfLayoutView': {
			height: 'calc(100% - 3rem)',
			top: '3rem',
		},
	},
})
